import { environmentBase } from './environment.base';
const BasePath: string = 'https://webapps.acep.org';
const BasePath_SEMPA: string = 'https://webapps.sempa.org';
const PrivateWebServicesBasePath: string = 'https://ws.acep.org/privatetoolkit';
export const environment = {
  base: environmentBase,
  localbase: BasePath,
  contactapiendpoint: PrivateWebServicesBasePath + '/api/contactapi/',
  dashboardapiendpoint: PrivateWebServicesBasePath + '/api/dashboardapi/',
  memberappapiendpoint: PrivateWebServicesBasePath + '/api/acepmemberappapi/',
  ninjaapiendpoint: BasePath + '/utils/api/ninja/',
  s3endPoint: BasePath + '/utils/api/s3/',
  loginurl: BasePath + '/SAML/sso.ashx?' + 'org=ACEP&redir=',
  logouturl: BasePath + '/Logout.aspx',
  PrivacyPolicyURL: 'https://www.acep.org/who-we-are/about-us/about-us/contact/privacy-policy-and-copyright-notice/',
  production: true,
  env: "prod"
};
